<!--
 * @Author: your name
 * @Date: 2022-03-10 00:25:21
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 09:08:39
 * @Description: file content
-->
<template>
  <div class="modal">
    <div class="record-exist">
      <span class="word5" @click="recordExit">关闭</span>
    </div>
    <div class="modal-header">
      <img src="@/assets/lottery/lottery_record.svg" />
    </div>
    <div class="modal-body">
      <span>{{ record }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      record: {
        type: String,
        required: true,
      },
    },
    methods: {
      recordExit(event) {
        console.log(event, "event");
        this.$emit("recordExit", event);
      },
    },
  };
</script>

<style lang="less" scoped>
  .modal {
    border-radius: 32px;
    background-color: snow;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    min-width: 300px;
    width: 80vw;
    height: 30vw;
    min-height: 300px;
    padding-top: 10px;
    box-sizing: border-box;
    margin-top: 150px;

    .record-exist {
      width: 10vw;
      height: 4vw;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 14px;
      position: relative;
      right: -35vw;
      top: -6vw;

      .word5 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 3vw;
        white-space: nowrap;
        line-height: 20px;
        text-align: center;
      }
    }

    .modal-header {
      flex: 2;
    }

    .modal-body {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      flex: 8;
      font-size: 4vw;
    }
  }
</style>
